import { styled } from "@linaria/react";
import React from "react";
import { color, fonts, zIndex } from "..";
import useEnsuredForwardedRef from "../lib/hooks/useEnsuredForwardedRef";
import useHeaderHeight, {
  PRIMARY_HEADER_HEIGHT_CSS_VARIABLE,
  SECONDARY_HEADER_HEIGHT_CSS_VARIABLE,
} from "./useHeaderHeight";

interface P {
  id?: string;
  nav?: React.ReactNode;
  title?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}

const Actions = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  color: ${color.carbon900};
  font: ${fonts.body1};
  font-weight: 500;
`;

const Title = styled.div``;

const Wrapper = styled.div`
  @media screen {
    position: sticky;
    top: var(${PRIMARY_HEADER_HEIGHT_CSS_VARIABLE});
  }

  @media print {
    display: none;
  }

  z-index: ${zIndex.fixedSubheader};
  border-bottom: 1px solid;
  border-bottom-color: ${color.titanium200};

  width: 100%;
  display: flex;
  justify-content: space-between;
  color: ${color.carbon900};
  background-color: ${color.hydrogen};
  padding: 0 30px;
  white-space: nowrap;
  ${Title} {
    margin-right: 10px;
  }

  & > * {
    min-height: 40px;
  }

  flex-wrap: wrap;
`;

const SecondaryHeader = (
  { nav, title, actions, id, className }: P,
  forwardedRef: React.Ref<HTMLDivElement>,
) => {
  const secondaryHeaderRef = useEnsuredForwardedRef(forwardedRef);
  useHeaderHeight(secondaryHeaderRef, SECONDARY_HEADER_HEIGHT_CSS_VARIABLE);
  return (
    <Wrapper ref={secondaryHeaderRef} id={id} className={className}>
      {title && <Title>{title}</Title>}
      {nav}
      {actions && <Actions>{actions}</Actions>}
    </Wrapper>
  );
};

export default React.forwardRef(SecondaryHeader);
